import { mergeStyles } from "@fluentui/react";
import React from "react";
import ReactHtmlParser from "react-html-parser";
import Banner from "./Banner.png";

interface HomeBannerProps {
  Title: string,
  Text: string,
}

// Consts //

const bannerStyle = mergeStyles({
  backgroundImage: `url(${Banner})`,
  backgroundPosition: "center center",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  color: "white",
  height: "auto",
  minHeight: "100px",
  width: "100%",
  marginBottom: "16px",
  boxSizing: "border-box",
  selectors: {
    "@media(min-width: 576px)": {
      padding: "4rem 2rem",
    },
    "@media(max-width:576px)": {
      background: "none",
      backgroundColor: "#001F57",
      padding: "1rem",
    },
    "@media(max-width:400px)": {
      padding: "0.5rem",
    },
  },
});

const HomeBanner: React.FunctionComponent<HomeBannerProps> = (props) => {
  return (
    <div className={`${bannerStyle} jumbotron`}>
      <div className="col-md-6">
        <h1 id="hometitle">
            {props.Title}
        </h1>
        <p>
            {ReactHtmlParser(props.Text)}
        </p>
      </div>
      <div className="col-md-6"></div>
    </div>
  );
};

export default HomeBanner;
